'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MOLECULE_NAME = 'toggle-section';

var ToggleSection = function (_Component) {
  _inherits(ToggleSection, _Component);

  function ToggleSection(props) {
    _classCallCheck(this, ToggleSection);

    var _this = _possibleConstructorReturn(this, (ToggleSection.__proto__ || Object.getPrototypeOf(ToggleSection)).call(this, props));

    _this.toggleOpenClose = _this.toggleOpenClose.bind(_this);

    _this.state = {
      sectionOpen: false
    };
    return _this;
  }

  _createClass(ToggleSection, [{
    key: 'toggleOpenClose',
    value: function toggleOpenClose() {
      var _this2 = this;

      var callback = this.props.callback;


      this.setState({
        sectionOpen: !this.state.sectionOpen
      }, function () {
        if (callback) {
          callback(_this2.state.sectionOpen);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          config = _props.config,
          content = _props.content,
          className = _props.className,
          children = _props.children;
      var id = config.id;
      var openIcon = content.openIcon,
          closeIcon = content.closeIcon,
          altText = content.altText;
      var sectionOpen = this.state.sectionOpen;


      return _react2.default.createElement(
        'div',
        { id: id, className: MOLECULE_NAME + '__container ' + className },
        _react2.default.createElement('button', {
          className: MOLECULE_NAME + '__button',
          style: { background: 'url(' + (sectionOpen ? closeIcon : openIcon) + ') no-repeat center' },
          onClick: this.toggleOpenClose
        }),
        sectionOpen ? _react2.default.createElement(
          'div',
          { className: MOLECULE_NAME + '__content' },
          children
        ) : _react2.default.createElement(
          'p',
          { className: MOLECULE_NAME + '__alt-text' },
          altText
        )
      );
    }
  }]);

  return ToggleSection;
}(_react.Component);

exports.default = ToggleSection;


ToggleSection.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    openIcon: _propTypes2.default.string.isRequired,
    closeIcon: _propTypes2.default.string.isRequired,
    altText: _propTypes2.default.string.isRequired
  }),
  callback: _propTypes2.default.func,
  className: _propTypes2.default.string,
  children: _propTypes2.default.element.isRequired
};

ToggleSection.defaultProps = {
  config: {
    id: ''
  },
  content: {
    openIcon: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/emea/gb/en/online-sellers-solutions/pink-close.png',
    closeIcon: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/emea/gb/en/online-sellers-solutions/pink-open.png',
    altText: 'Click to see details'
  },
  className: '',
  callback: function callback() {}
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/molecules/toggle-section/jsx/ToggleSection.js
// module id = 1067
// module chunks = 4